<template>
  <div class="center">
    <p>
      Aguardando confirmação da compra<br />
      <i class="el-icon-loading fa-3x"></i>
    </p>
    <p>
      Processando ... <span>{{ count }}s</span>
    </p>

  </div>
</template>

<script>
import { PaymentService } from "@/services/customers/payment.services";
export default {
  name: 'PaymentFinished',
  props: {
    value: Number,
    token: String,
    customer: String,
    billetId: String,
  },
  computed: {
    almost() {
      return this.count < 30;
    },
    expired() {
      return this.count === 0;
    }
  },
  data() {
    return {
      interval: null,
      id: "",
      url: "",
      code: "",
      count: 1,
    }
  },
  activated() {
    console.log('activated');
  },
  created() {
    console.log('created');
  },
  methods: {
    open() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      PaymentService.card({
        value: vm.value,
        token: vm.token,
        description: "MaisEnvios - Credito",
        billetId: this.billetId,
        customer: vm.customer,
      })
        .then((response) => {
          console.log('response', response)
          clearInterval(vm.interval);
          vm.$emit('payment', response.status, response.success);
        })
        .catch((error) => {
          this.$message({ type: "error", message: error });
        }).finally(() => setTimeout(() => {
          loading.close();
        }, 300))

    },
    updated() {
      this.interval = setInterval(() => {
        this.count++;
      }, 1000);
    }
  },
  mounted() {
    console.log('mounted', this.type);
    this.updated();
  }
}
</script>
